/**
 * Mensagem de erro apresentável a partir de uma falha do Axios.
 *
 * O backend responde `{"error": "..."}` com o motivo real (colaborador
 * bloqueado, cota excedida, empresa bloqueada). Sem isso o usuário só vê
 * "Request failed with status code 403" e não sabe o que fazer.
 */
export const extractErrorMessage = (err: unknown, fallback: string): string => {
  const responseError = (err as { response?: { data?: { error?: string; message?: string } } })
    ?.response?.data;

  const backendMessage = responseError?.error ?? responseError?.message;

  if (backendMessage) {
    return backendMessage;
  }

  return err instanceof Error && err.message ? err.message : fallback;
};
